module.exports = __webpack_public_path__ + "static/pwned-169ea4598357f270e70063f97505b6fb.svg";